/* eslint-disable import/prefer-default-export,max-len,import/named,import/no-cycle */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getShiftedPoint } from '../../../../share/utils/line';
import { getNextId, splice, toInches } from '../../../../share/utils/general';
import { getDelta } from '../../../../share/utils/point';
import { getSidePerLineId, moveLotLine, splitLotLine } from '../../../../share/utils/lotline';
import { ILotLine } from '../../../../share/types';
import { buildPolygonFromLines } from '../../helpers';
import { IRootState } from '../../../../share/store/store';
import { Counter } from '../../../../share/utils/general/counter';

export const setLineLengthAction = createAsyncThunk(
  'lot/setLineLengthAction',
  async (payload: { line: ILotLine, length: number }, { getState }) => {
    const { lotReducer: { present: { lotLines } } } = getState() as IRootState;
    const { line, length } = payload;
    const point = getShiftedPoint({ line, newLength: toInches(length) });
    const delta = getDelta(line.endPoint, point);
    const sidePerId = getSidePerLineId(line.endPoint, lotLines);
    const lines = moveLotLine(lotLines, delta, sidePerId);
    const polygon = buildPolygonFromLines(lines);
    return ({ lotLines: lines, polygon });
  },
);

export const addLineVertexAction = createAsyncThunk(
  'lot/addLineVertexAction',
  async (payload: { line: ILotLine }, { getState }) => {
    const { lotReducer: { present: { lotLines } } } = getState() as IRootState;
    const { line } = payload;
    const index = lotLines.indexOf(line);
    const counter = new Counter(getNextId(lotLines));
    const lines = splice(
      lotLines,
      { index },
      ...splitLotLine(line, counter),
    ) as ILotLine[];
    const polygon = buildPolygonFromLines(lines);
    return ({ lotLines: lines, polygon });
  },
);
